import ZonePointType from "../../../enums/robot/rooms/zone-point-type";
import IdTypePoint from "./id-type-point";

interface IBaseZone {
  id: string;
  room: string;
  points: { orderIndex: number; point: IdTypePoint }[];
}

export interface IBaseZoneApi {
  id: string;
  room: string;
  points: number[][];
}

export default IBaseZone;

export const mapApiPointToIdTypePoint = (apiData: number[], type: ZonePointType, id: string) => {
  if (apiData.length !== 3) return null;
  return {
    coordinateX: apiData[0],
    coordinateY: apiData[1],
    coordinateTheta: apiData[2],
    id: id,
    type,
  } as IdTypePoint;
};

export const mapApiPointsToPoints = (apiData: number[][], type: ZonePointType) => {
  const points: { orderIndex: number; point: IdTypePoint }[] = [];

  apiData.forEach((point, index) => {
    if (point.length === 3)
      points.push({
        orderIndex: index,
        point: mapApiPointToIdTypePoint(point, type, index.toString())!,
      });
  });

  return points;
};

export const mapPointsToApi = (points: IdTypePoint[]) => {
  const apiData: number[][] = [];

  points.forEach((point) => {
    apiData.push([point.coordinateX, point.coordinateY, point.coordinateTheta ?? 0]);
  });
  return apiData;
};
